import { render } from "./Tools.vue?vue&type=template&id=5cec77d2&scoped=true&ts=true&lang=pug"
import script from "./Tools.vue?vue&type=script&lang=ts"
export * from "./Tools.vue?vue&type=script&lang=ts"

import "./Tools.vue?vue&type=style&index=0&id=5cec77d2&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cec77d2"]])

export default __exports__